export default __webpack_public_path__ + "static/media/Websites- NY times.e790cd7a.png";